import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { portalApi } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Loader2, Building2 } from "lucide-react";

function fmtDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function PortalLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await portalApi.login(email, password);
      navigate("/portal");
    } catch (err) {
      setError(fmtDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#f4f7fa] px-6" data-testid="portal-login-page">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 justify-center mb-8">
          <div className="w-10 h-10 rounded-sm bg-[#00579e] flex items-center justify-center text-white">
            <Building2 className="w-5 h-5" />
          </div>
          <div>
            <div className="cs-heading text-lg font-semibold leading-tight">Acme Managed Cloud</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Customer Portal</div>
          </div>
        </div>

        <form onSubmit={submit} className="cs-card p-8" data-testid="portal-login-form">
          <h2 className="cs-heading text-base font-semibold mb-1">Sign in to your billing portal</h2>
          <p className="text-xs text-muted-foreground mb-6">View your invoices and reconciling usage reports.</p>

          <label className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground">Email</label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="billing@yourcompany.com" autoComplete="email" required
            data-testid="portal-email-input" className="rounded-sm mt-1 mb-4" />
          <label className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground">Password</label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••" autoComplete="current-password" required
            data-testid="portal-password-input" className="rounded-sm mt-1" />

          {error && (
            <div className="text-xs text-[#b91c1c] bg-[#fee2e2] border border-[#ef4444]/40 rounded-sm p-2 mt-4" data-testid="portal-login-error">
              {error}
            </div>
          )}

          <Button type="submit" disabled={busy} data-testid="portal-login-submit"
            className="w-full mt-6 rounded-sm bg-[#00579e] hover:bg-[#004580] text-white h-10">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
          </Button>
        </form>
        <div className="text-center text-[10px] text-muted-foreground mt-4">
          Powered by CloudScore PartnerOps · Access is scoped to your organization's invoices only
        </div>
      </div>
    </div>
  );
}
